export enum TypeFilters {
  Consignee = 'consignee',
  PaymentType = 'payment_type'
}
